import { useTranslation } from 'react-i18next'
import { Input } from '@structural-climbing/ui'

interface MemberSearchInputProps {
  value: string
  onValueChange: (v: string) => void
  className?: string
}

export function MemberSearchInput({ value, onValueChange, className }: MemberSearchInputProps) {
  const { t } = useTranslation()
  return (
    <Input
      size="sm"
      placeholder={t('members.searchPlaceholder')}
      value={value}
      onValueChange={onValueChange}
      className={className}
    />
  )
}
